module.exports = __webpack_public_path__ + "static/media/e-continuum-sample.1bd21e03.png";